const retryButtonTransitionDurationMs = 100;
const entry = "_275echtj4t";
const meta = "_275mqamr0q";
const date = "_275d16bwiw9";
const messageWrapper = "_275mi0ljzd";
const message = "_275m1yca0ma";
const retryButton = "_275ri1k65t";

export { date, entry, message, messageWrapper, meta, retryButton, retryButtonTransitionDurationMs };
import "./atom.dialogue-entry.style.linaria.module.css";
//# sourceMappingURL=atom.dialogue-entry.style.js.map
